module.exports = __webpack_public_path__ + "static/media/IMG_0744.7e3fcc9d.jpg";